import React, { useRef, useState, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { isEmpty, maskingMobile } from "bodycodi/cmap/app/js/common";
import MemberType from "bodycodi/cmap/app/components/common/MemberType";
import Pass from "bodycodi/cmap/app/components/common/pass";
import PassEmpty from "bodycodi/cmap/app/components/common/passEmpty";
import down from "bodycodi/cmap/app/img/down.png";
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import {
  DispatchContext as HomeDispatchContext,
  StateContext,
} from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

type MemberProp = {
  d: any;
  clickPass: Function;
};

const MemberPass = ({ d, clickPass }: MemberProp) => {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { state: stateContext } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const imgUrl = isEmpty(d.imgUrl) ? empty : d.imgUrl;
  const [open, setOpen] = useState(false);
  const [swiper, setSwiper] = useState<any>({});
  const foldWrap = useRef<HTMLDivElement>(null);
  const fold = useRef<HTMLDivElement>(null);
  const dotWrap = useRef<HTMLDivElement>(null);
  const [openPass, setOpenPass] = useState(false);

  const clickMember = () => {
    setOpen(!open);
  };

  const slideChange = () => {
    const index = swiper.activeIndex;
    const children = dotWrap.current?.querySelectorAll(".dot")!;
    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove("active1");
    }
    children[index].classList.add("active1");
  };

  const handleClickEmptyPass = () => {
    homeDispatch({
      type: "UPDATE",
      data: {
        memberDtlPopData: {
          seqPartner: stateContext.member.seqPartner,
          seqPartnerBranch: stateContext.member.seqPartnerBranch,
          seqMember: d.seqMember,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: true } });
  };

  const passList = d.passInfos.map((d1: any) => {
    return (
      <SwiperSlide key={d1.seqPassInfo} className="member-slide">
        <Pass
          d={d1}
          member={d}
          onClick={clickPass}
          swiperWrap={fold}
          isAdd={true}
          open={openPass}
          setOpen={setOpenPass}
        />
      </SwiperSlide>
    );
  });

  return (
    <>
      <div className="member-mngt" onClick={clickMember}>
        <div className="profile-wrap">
          <img className="profile" src={imgUrl} />
          {d.entranceMemberYn === "Y" && <div className="entrance"></div>}
        </div>
        <div className="text">
          <div className="title">
            <div className="bold">{d.name}</div>
            <MemberType
              appointmentMemberYn={d.appointmentMemberYn}
              chargeMemberYn={d.chargeMemberYn}
              isSmall
            />
          </div>
          <div className="desc">
            <span>{maskingMobile(d.mobile)} &#183; </span>
            {d.age === 0 || isEmpty(d.age) ? (
              <span className="no-age">나이 미설정</span>
            ) : (
              <span>만 {d.age}세</span>
            )}
          </div>
        </div>
        <img src={down} className={`down ${open && "rotate"}`} />
      </div>
      <div className={"fold-wrap" + (open ? " open" : " close")} ref={foldWrap}>
        <div className="fold" ref={fold}>
          <Swiper
            onSwiper={(swiper) => {
              setSwiper(swiper);
            }}
            onSlideChange={slideChange}
            spaceBetween={12}
            centeredSlides={true}
            slidesPerView="auto"
            className="member-swiper"
            autoHeight={true}
          >
            {d.passInfos.length === 0 ? (
              <SwiperSlide className="member-slide">
                <PassEmpty from="schedule" onClick={handleClickEmptyPass} />
              </SwiperSlide>
            ) : (
              passList
            )}
          </Swiper>
          <div className="member-pass-list-dot-wrap bottom-mg" ref={dotWrap}>
            {d.passInfos.length > 1 && (
              <div className="dot-wrap">
                {d.passInfos.map((d: any, i: number) => {
                  return <div className={"dot" + (i === 0 ? " active1" : "")} key={i}></div>;
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberPass;
